import { createSelector, createFeatureSelector } from '@ngrx/store';

import { DeliveryAsset, TrackTypes } from 'app/core/models/delivery-asset.model';
import { DeliveryAudioAssetState } from './audio-asset.reducer';

export const getDeliveryAssetState = createFeatureSelector<DeliveryAudioAssetState>(
  'AudioAssetReducer',
);

export const getDeliveryAudioAssets = createSelector(
  getDeliveryAssetState,
  (resp: DeliveryAudioAssetState) => resp.assets,
);

export const getSelectedAudioAsset = createSelector(
  getDeliveryAudioAssets,
  (assets: DeliveryAsset[]) => {
    const selected = assets
      .filter((fAsset: DeliveryAsset) => !!fAsset?.types?.find((trackType: TrackTypes) => trackType?.type === 'Streaming'))
      .find((asset: DeliveryAsset) => asset.isSelected);
    return selected || <DeliveryAsset>{};
  },
);

export const selectAudioTrackIsPlaying = createSelector(
  getSelectedAudioAsset,
  (asset: DeliveryAsset) => asset?.isPlaying,
);
